import { GatsbyImage, getImage, ImageDataLike } from 'gatsby-plugin-image';
import React, { FC } from 'react';
import './SectionImageCard.scss';

interface ISectionImageCard {
    eyebrow?: string;
    title: string;
    image: {
        src: ImageDataLike;
        alt: string;
    };
}
export const SectionImageCard: FC<{ inputs: ISectionImageCard }> = ({
    inputs,
}) => {
    return (
        <>
            <figure className="section-image-card">
                <GatsbyImage
                    image={getImage(inputs.image?.src)}
                    alt={inputs.image?.alt}
                />
                <div className="section-image-card__text-content">
                    {inputs.eyebrow && (
                        <p className="section-image-card__eyebrow">
                            {inputs.eyebrow}
                        </p>
                    )}
                    <figcaption>
                        <h3 className="section-image-card__title">
                            {inputs.title}
                        </h3>
                    </figcaption>
                </div>
            </figure>
        </>
    );
};
